import axios from 'axios';
import { useEffect, useState } from 'react';
import { Divider, Typography, useTheme } from "@mui/material";
import Icons from './Icons';
import FlexBetween from "components/FlexBetween";
import WidgetWrapper from "components/WidgetWrapper";

const AdvertWidget = () => {
  const { palette } = useTheme();
  const dark = palette.neutral.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;
  const [judgingFreedomVideo, setJudgingFreedomVideo] = useState(null);
  const [trendsJournalVideo, setTrendsJournalVideo] = useState(null);
  const [joeyBToonzVideo, setJoeyBToonzVideo] = useState(null);

  useEffect(() => {
    const fetchLatestVideo = async (channelId, setter) => {
      try {
        const res = await axios.get(`/api/youtube/latest-video/${channelId}`);
        setter(res.data.videoId);
      } catch (err) {
        console.error(`Error fetching video for channel ${channelId}:`, err);
      }
    };
  
    // Replace with correct channel IDs
    fetchLatestVideo('UCDkEYb-TXJVWLvOokshtlsw', setJudgingFreedomVideo); // Judging Freedom
    fetchLatestVideo('UCqEP1KaO5w61OmzyK6nYfjg', setTrendsJournalVideo);   // Trends Journal
    fetchLatestVideo('UCaEWTaMKp1EWQ_lqqzfu6Nw', setJoeyBToonzVideo);       // Joey B Toonz
  
  }, []);
  


  return (
    <WidgetWrapper style={{ height: '400px', overflowY: 'auto' }}>

      <FlexBetween >

        <Typography
          sx={{ ml: "80px !important" }}
          color="#8a0303" variant="h5" fontWeight="500" style={{ textAlign: "center !important" }}>
          Judging Freedom
        </Typography>
      </FlexBetween>
      <iframe
        width="100%"
        height="auto"
        src="https://www.youtube.com/embed/T4XU9O3vEQA"
        title="YouTube Video"
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        allowFullScreen
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography color={main} style={{ marginRight: "1rem" }}>
          Judge Andrew P. Napolitano
        </Typography>

        <a
          href="https://judgenap.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: medium }}
        >
          https://www.youtube.com/@judgingfreedom
        </a>
      </div>
      <Typography color={medium} m="0.5rem 0"> Hard-hitting legal/political news from a man who knows and respects the Constitution and the importance of defending individual freedoms.
      </Typography>
      <Divider />

      <FlexBetween >

        <Typography
          sx={{ ml: "80px !important" }}
          color="#8a0303" variant="h5" fontWeight="500" style={{ textAlign: "center !important" }}>
          Trends Journal
        </Typography>
      </FlexBetween>
      <iframe
        width="100%"
        height="auto"
        src="https://www.youtube.com/embed/AEoaM_q2fgQ"
        title="YouTube Video"
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        allowFullScreen
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography color={main} style={{ marginRight: "1rem" }}>
          Gerald Celente
        </Typography>

        <a
          href="https://trendsjournal.com/subscribe/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: medium }}
        >
          https://www.youtube.com/@gcelente
        </a>
      </div>
      <Typography color={medium} m="0.5rem 0">
        Gerald Celente is the Founder/Director of the Trends Research Institute and Publisher of the Trends Journal.  With a 40-year track record of identifying, tracking and forecasting trends, Celente is world-renowned as today's #1 Trend Forecaster.
      </Typography>
      <Divider />

      <FlexBetween >
        <Typography
          sx={{ ml: "80px !important" }}
          color="#8a0303" variant="h5" fontWeight="500" style={{ textAlign: "center !important" }}>
          Idiocracy
        </Typography>
      </FlexBetween>
      <iframe
        width="100%"
        height="auto"
        src="https://www.youtube.com/embed/IvxQm4Djsho"
        title="YouTube Video"
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        allowFullScreen
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography color={main} style={{ marginRight: "1rem" }}>
          Joey B Toonz
        </Typography>

        <a
          href="https://www.patreon.com/joeybtoonz"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: medium }}
        >
          www.patreon.com/joeybtoonz
        </a>
      </div>
      <Typography color={medium} m="0.5rem 0">
        The world is like a Rubik's Cube – twisted, confusing, and everyone's trying to figure out how to make it right without breaking it further
      </Typography>
      <Divider />



      <FlexBetween >
        <Typography
          sx={{ ml: "80px !important" }}
          color="#8a0303" variant="h3" fontWeight="500" style={{ textAlign: "center !important" }}>
          Audio Books
        </Typography>
      </FlexBetween>
      <iframe
        width="100%"
        height="auto"
        src="https://www.youtube.com/embed/zY78xiw4thY"
        title="YouTube Video"
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        allowFullScreen
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography color={main} style={{ marginRight: "1rem" }}>
          Milton William Cooper
        </Typography>

        <a
          href="https://www.youtube.com/watch?v=8fmppggRoyk"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: medium }}
        >
          https://www.youtube.com/watch?v=8fmppggRoyk/
        </a>
      </div>
      <Typography color={medium} m="0.5rem 0">
        “All that is necessary for evil to triumph is for good men to do nothing.“ - MWC
      </Typography>


      <Divider />

      <FlexBetween >
        <Typography
          sx={{ ml: "80px !important" }}
          color="#8a0303" variant="h3" fontWeight="500" style={{ textAlign: "center !important" }}>
          Permanent Record
        </Typography>
      </FlexBetween>
      <iframe
        width="100%"
        height="auto"
        src="https://www.youtube.com/embed/MI5xj5XshVg"
        title="YouTube Video"
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        allowFullScreen
      />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography color={main} style={{ marginRight: "1rem" }}>
          Edward Snowden
        </Typography>

        <a
          href="https://www.youtube.com/watch?v=NRzDsxUOm4M"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: medium }}
        >
          Citizenfour
        </a>
      </div>
      <Typography color={medium} m="0.5rem 0">
        “Ultimately, arguing that you don't care about the right to privacy because you have nothing to hide is no different than saying you don't care about free speech because you have nothing to say.” - ES
      </Typography>





    </WidgetWrapper>
  );
};

export default AdvertWidget;